export enum BillingReport {
  payments = "payments",
  orders = "orders",
}
